import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";

const InputWrapper = styled.div`
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  transition: box-shadow 0.2s;

  box-shadow: ${({ isFocused }) =>
    isFocused ? "4.462px 4.462px 7.808px rgba(0, 0, 0, 0.12)" : "none"};
`;

const CourseTitleInput = styled.textarea`
  resize: none;
  max-height: 88px;
  width: 100%;
  padding: 8px 15px;
  font-size: 16px;
  line-height: 24px;
  color: #1e1e1e;

  ::-webkit-scrollbar {
    width: 3px;
  }
`;

const CourseDescriptionInput = styled(CourseTitleInput)``;

const CourseTitleAndDescription = ({
  courseSettingsData,
  setCourseSettingsData,
}) => {
  const courseTitleInputRef = useRef(null);
  const courseDescriptionInputRef = useRef(null);

  const [isTitleFocused, setIsTitleFocused] = useState(false);
  const [isDescriptionFocused, setIsDescriptionFocused] = useState(false);

  const handleCourseTitleInput = useCallback((event) => {
    setCourseSettingsData((prevState) => ({
      ...prevState,
      course_name: event.target.value,
    }));
  }, []);

  useEffect(() => {
    if (courseTitleInputRef.current) {
      courseTitleInputRef.current.style.height = "auto";
      courseTitleInputRef.current.style.height =
        courseTitleInputRef.current.scrollHeight + "px";
    }
  }, [courseSettingsData.course_name, courseTitleInputRef]);

  const handleCourseDescriptionInput = useCallback((event) => {
    setCourseSettingsData((prevState) => ({
      ...prevState,
      course_description: event.target.value,
    }));
  }, []);

  useEffect(() => {
    if (courseDescriptionInputRef.current) {
      courseDescriptionInputRef.current.style.height = "auto";
      courseDescriptionInputRef.current.style.height =
        courseDescriptionInputRef.current.scrollHeight + "px";
    }
  }, [courseSettingsData.course_description, courseDescriptionInputRef]);

  return (
    <>
      <InputWrapper isFocused={isTitleFocused}>
        <CourseTitleInput
          ref={courseTitleInputRef}
          placeholder="Название курса"
          type="text"
          rows={1}
          value={courseSettingsData.course_name || ""}
          onChange={handleCourseTitleInput}
          onFocus={() => setIsTitleFocused(true)}
          onBlur={() => setIsTitleFocused(false)}
        />
      </InputWrapper>

      <InputWrapper isFocused={isDescriptionFocused}>
        <CourseDescriptionInput
          ref={courseDescriptionInputRef}
          placeholder="Описание"
          type="text"
          rows={1}
          value={courseSettingsData.course_description || ""}
          onChange={handleCourseDescriptionInput}
          onFocus={() => setIsDescriptionFocused(true)}
          onBlur={() => setIsDescriptionFocused(false)}
        />
      </InputWrapper>
    </>
  );
};

export default memo(CourseTitleAndDescription);
